/* istanbul ignore file */
/**
 * Created by rathompson on 9/13/21
 * File: Identities
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

import IdentitiesTableOld from './table/IdentitiesTable/IdentitiesTableOld'
import IdentitiesTable from './table/IdentitiesTable/IdentitiesTable'
import { getVarValue } from '../../../common/utils/Sparky'
import { FF_IAM_PHASE_1 } from '../../../common/utils/FeatureFlags'

const iamPhase1 = getVarValue(FF_IAM_PHASE_1, false)

/***
 * @returns {JSX.Element}
 * @constructor
 * @desc IAM service page
 */
const Identities = (props) => {
  return iamPhase1 ? (
    <IdentitiesTable {...props}/>
  ) : (
    <IdentitiesTableOld {...props}/>
  )
}
export default Identities
